<div romaProSelect [featureUser]="featureUser" class="wrapper-pro-feature-user">
  <roma-modal-template
    [title]="'clockHour.create.form.title' | translate"
    [showCancelBtn]="false"
    [isLoading]="loading"
    [askBeforeClose]="haveChanges"
    [disableSecondary]="wrongTime || hasOverlapError"
    [disableSuccess]="wrongTime || hasOverlapError"
    (success)="submit()"
    (cancel)="close()"
  >
    <form
      [formGroup]="form"
      romaProSelect
      class="wrapper-pro-feature-user"
      [featureUser]="featureUser"
    >
      <div class="row">
        <div class="col-12">
          <div class="date-hours-info">
            <div class="date">
              <span>{{ 'clockHour.create.form.date' | translate }}</span>
              {{
                dataParams?.date
                  ? (dataParams?.date | dateDayMonthConvert | titlecase)
                  : (null | dateDayMonthConvert | titlecase)
              }}
            </div>
            <div class="hours">
              <span>TOTAL</span>
              {{
                {
                  histories: form.get('histories').value,
                  breaks: form.get('breaks').value
                } | clockHoursDuration
              }}
            </div>
          </div>
        </div>
      </div>

      <!-- selector by hours -->
      <roma-add-time
        style="margin-top: 30px"
        [mode]="mode"
        [data]="histories || []"
        [disabled]="blockEdition"
        (changes)="changeClockHistories($event)"
        [stopwatchMandatory]="clockInWithStopwatchMandatory"
      >
      </roma-add-time>
      <!-- selector by hours -->
      <roma-add-break
        style="margin-top: 30px"
        [mode]="mode"
        [data]="breaks || []"
        [disabled]="blockEdition"
        (changes)="changeClockBreaks($event)"
      >
      </roma-add-break>

      <div
        *ngIf="blockEdition"
        class="roma-disclaimer warning"
        style="margin-bottom: 10px"
      >
        <div class="icon">
          <img
            src="assets/icons/gl_alert_yellow.svg"
            style="width: 24px; height: 24px"
          />
        </div>
        <div class="body">
          {{ 'clockHour.disclaimerBlock' | translate }}
        </div>
      </div>

      <div class="error-container">
        <label *ngIf="wrongTime">
          <ng-container *ngIf="!equalTime"
            >*{{
              'clockHour.create.form.errorHistories' | translate
            }}</ng-container
          >
        </label>

        <label *ngIf="hasOverlapError">
          {{ 'clockHour.create.form.overlapError' | translate }}
        </label>
      </div>

      <!-- type selection -->
      <p class="title-notes">
        {{ 'clockHour.shiftType' | translate }}
      </p>
      <mat-radio-group
        style="margin-bottom: 20px"
        formControlName="type"
        class="radio-group"
        [disabled]="blockEdition"
      >
        <mat-radio-button [value]="typeRef.remote">
          {{ 'clockHour.type.remote' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="typeRef.onsite">
          {{ 'clockHour.type.on-site' | translate }}
        </mat-radio-button>
      </mat-radio-group>

      <!-- note -->
      <p class="title-notes">
        {{ 'general.notes' | translate }}
      </p>

      <div>
        <textarea
          cols="30"
          rows="1"
          class="note-input"
          formControlName="note"
          maxlength="255"
          [placeholder]="'equipments.create.notePh' | translate"
        >
        </textarea>
      </div>
      <div
        *ngIf="dataParams?.status === statusRef.Rejected"
        class="data-flex-container"
      >
        <div class="item item-name">{{ 'general.reason' | translate }}:</div>
        <div class="item item-info">
          <ng-container *ngIf="dataParams?.reasonRejected?.description">
            {{ dataParams?.reasonRejected?.description }}
          </ng-container>

          <ng-container *ngIf="!dataParams?.reasonRejected?.description">
            -
          </ng-container>
        </div>
      </div>
      <roma-shift-history *ngIf="id" [id]="id"></roma-shift-history>
    </form>
  </roma-modal-template>
</div>
